import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';

/* === ClickMagick Tracking (inject into <head>) === */
if (!document.querySelector('script[src="//cdn.clkmc.com/cmc.js"]')) {
  const cmInline = document.createElement('script');
  cmInline.innerHTML = `
    window.clickmagick_cmc = {
      uid: '141056',
      hid: '808495452',
      cmc_project: 'TFF',
      log_action: '.cta',
      vid_info: 'on',
      utm_content: 'DO.BTF.BACKINTIME',
    };
  `;
  document.head.appendChild(cmInline);
  const cmExternal = document.createElement('script');
  cmExternal.src = '//cdn.clkmc.com/cmc.js';
  cmExternal.async = true;
  document.head.appendChild(cmExternal);
}
/* === End ClickMagick Tracking === */

/* === Hotjar / Contentsquare Tracking (inject into <head>) === */
if (!document.querySelector('script[src="https://t.contentsquare.net/uxa/dc0bea528efc9.js"]')) {
  const hotjarScript = document.createElement('script');
  hotjarScript.src = 'https://t.contentsquare.net/uxa/dc0bea528efc9.js';
  hotjarScript.async = true;
  document.head.appendChild(hotjarScript);
}
/* === End Hotjar / Contentsquare Tracking === */

render(<App data-id="element-463" />, document.getElementById('root'));